/* global viabovag */
import {
    camelToKebab,
    closest,
    delegateEvent,
    scrollTo,
    stripWhiteSpace,
    toggle,
    touchesViewport,
    triggerJs,
    elementOrParentsHasOneOfClassNames
} from 'js/tools';
import { getMobilityTypeFromVehicleNode, getProductDataFromVehicleNode, registerEcommerceEvent } from 'js/ecommerce';
import { renderLastSearchRequest, setLastSearchRequest } from 'js/searchRequest_v2';
import registerEvent from 'js/web-event-api-wrapper';
import apiConnector from 'js/apiConnector';
import breakpoints from 'js/breakpoints';
import mediaLoader from 'js/mediaLoader';
import validator from 'js/validator';
import ToolTips from 'js/toolTips';
import * as Analytics from 'js/analytics';
import validationPatterns from 'js/validationPatterns';

import checkboxGroup from 'components/checkboxGroup/checkboxGroup';
import ctaCall from 'components/ctaCall/ctaCall';
import Toast from 'components/toast/toast';

const ATTR_STATE = 'data-state';
const ATTR_VIEWED = 'data-viewed';

const CLASS_INPUT_AUTOCOMPLETE = 'input-autocomplete';
const CLASS_BUTTON_SNAPPED = 'fixed-actions--snapped';
const CLASS_CTA_PRIMARY_WITH_ICON = 'cta-primary--with-icon';
const CLASS_FILTERS_ARE_SHOWN = 'filters-are-shown';
const CLASS_INPUT_SELECT = 'input-select';
const CLASS_INPUT_TEXT = 'input-text';
const CLASS_INPUT_POSTAL_CODE = 'input-text--postal-code';
const CLASS_NO_RESULTS = 'no-results-found';
const CLASS_SINGLE_RESULT = 'single-result-found';

const ID_BRAND = 'Brand';
const ID_CAR_COMPANY_FILTER = 'CarCompanyId-CarCompanyName';
const ID_CITY_DISTANCE_FILTER = 'City-Distance';
const ID_IN_STOCK = 'InStock';
const ID_KEYWORDS = 'Keywords';
const ID_MODEL_KEYWORDS = 'ModelKeywords';
const ID_POSTAL_CODE_DISTANCE_FILTER = 'PostalCode-Distance';
const ID_COMPANY_FRANCHISE_FILTER = 'CompanyFranchise';

const SELECTOR_ABSOLUTE_WRAPPER = '.absolute-wrapper';
const SELECTOR_ACCESSORY_GROUPS = '[data-accessory-items]';
const SELECTOR_CHECKBOX_GROUP = '.checkbox-group';
const SELECTOR_CHECKBOXES = 'input[type="checkbox"]';
const SELECTOR_COUNT_NODE = '[data-js-count]';
const SELECTOR_DYNAMIC_WRAPPER = '.search-results__dynamic';
const SELECTOR_FIELD_BRAND = '[name="Brand"]';
const SELECTOR_FIELD_CAR_COMPANY_ID = '[name="CarCompanyId"]';
const SELECTOR_FIELD_CAR_COMPANY_NAME = '[name="CarCompanyName"]';
const SELECTOR_FIELD_DISTANCE = '[name="Distance"]';
const SELECTOR_FIELD_IN_STOCK = '[name="InStock"]';
const SELECTOR_FIELD_MOBILITY_TYPE = '[name="MobilityType"]';
const SELECTOR_FIELD_MODEL = '[name="Model"]';
const SELECTOR_FIELD_PAGE_NUMBER = '[name="PageNumber"]';
const SELECTOR_FIELD_POSTAL_CODE_CITY = '[name="PostalCodeCity"]';
const SELECTOR_FIELD_SORT_ORDER = '[name="SortOrder"]';
const SELECTOR_FIELD_SORT_ORDER_SELECT = '[name="SortOrderSelect"]';
const SELECTOR_FIELD_COMPANY_FRANCHISE = '[name="CompanyFranchise"]';
const SELECTOR_FILTER_CLOUD = '[data-daisy-component="filter-cloud"]';
const SELECTOR_FIELDSET_ITEM = '.fieldset__item';
const SELECTOR_FILTER_ITEM = '.filter__item';
const SELECTOR_FILTER_TOGGLER = '.open-filters';
const SELECTOR_FILTERS_CONTAINER = '.filters-container';
const SELECTOR_FIXED_ACTIONS = '.fixed-actions';
const SELECTOR_FORM = '.search-filters form';
const SELECTOR_KEYWORDS_FIELD = '.filters-container .input-search[data-name="Keywords"]';
const SELECTOR_MODEL_KEYWORDS_FIELD = '.filters-container .input-search[data-name="ModelKeywords"]';
const SELECTOR_SEARCH_FILTER = '.search-filters';
const SELECTOR_SEARCH_RESULT = '.search-result';
const SELECTOR_SEARCH_RESULTS = '.search-results';
const SELECTOR_DATA_SEARCH_COOKIE = '[data-js-vdp-interaction]';
const SELECTOR_SELECT_FIELDS = 'select:not([name="Distance"])';
const SELECTOR_SUBMIT_BUTTON = '.open-filters';
const SELECTOR_TOAST = '.toast';

const COOKIE_SRP_NAME = 'search-result-interaction';
const COOKIE_SRP_MAX = 25;

const STATE_BUSY = 'busy';
const STATE_IDLE = 'idle';

const SORTING_DISTANCE_OPTION_ENABLEDTEXT = 'Afstand';
const SORTING_DISTANCE_OPTION_DISABLEDTEXT = 'Afstand (vul eerst een postcode of plaats in)';

const RESULTS_SHOWN_AMOUNT = 25;

export default context => {
    const refs = {
        absoluteWrapper: context.querySelector(SELECTOR_ABSOLUTE_WRAPPER),
        accessoryGroups: context.querySelectorAll(SELECTOR_ACCESSORY_GROUPS),
        checkboxGroups: context.querySelectorAll(SELECTOR_CHECKBOX_GROUP),
        countNodes: context.querySelectorAll(SELECTOR_COUNT_NODE),
        dynamicWrapper: context.querySelector(SELECTOR_DYNAMIC_WRAPPER),
        fieldBrand: context.querySelector(SELECTOR_FIELD_BRAND),
        fieldCarCompanyName: context.querySelector(SELECTOR_FIELD_CAR_COMPANY_NAME),
        fieldCarCompanyId: context.querySelector(SELECTOR_FIELD_CAR_COMPANY_ID),
        fieldDistance: context.querySelector(SELECTOR_FIELD_DISTANCE),
        fieldInStock: context.querySelector(SELECTOR_FIELD_IN_STOCK),
        fieldMobilityType: context.querySelector(SELECTOR_FIELD_MOBILITY_TYPE),
        fieldModel: context.querySelector(SELECTOR_FIELD_MODEL),
        fieldPageNumber: context.querySelector(SELECTOR_FIELD_PAGE_NUMBER),
        fieldPostalCodeCity: context.querySelector(SELECTOR_FIELD_POSTAL_CODE_CITY),
        fieldSortOrder: context.querySelector(SELECTOR_FIELD_SORT_ORDER),
        fieldSortOrderSelect: context.querySelector(SELECTOR_FIELD_SORT_ORDER_SELECT),
        filterCloudNode: context.querySelector(SELECTOR_FILTER_CLOUD),
        filterToggler: context.querySelector(SELECTOR_FILTER_TOGGLER),
        filtersContainer: context.querySelector(SELECTOR_FILTERS_CONTAINER),
        fixedActions: context.querySelector(SELECTOR_FIXED_ACTIONS),
        form: context.querySelector(SELECTOR_FORM),
        keywordsField: context.querySelector(SELECTOR_KEYWORDS_FIELD),
        modelKeywordsField: context.querySelector(SELECTOR_MODEL_KEYWORDS_FIELD),
        searchFilters: context.querySelector(SELECTOR_SEARCH_FILTER),
        searchResults: context.querySelector(SELECTOR_SEARCH_RESULTS),
        submitButton: context.querySelector(SELECTOR_SUBMIT_BUTTON),
        toast: document.querySelector(SELECTOR_TOAST),
        fieldCompanyFranchise: context.querySelector(SELECTOR_FIELD_COMPANY_FRANCHISE)
    };

    const getters = {
        get checkboxes() {
            return context.querySelectorAll(SELECTOR_CHECKBOXES);
        },
        get inputSelectOrderNode() {
            return closest(context.querySelector(SELECTOR_FIELD_SORT_ORDER_SELECT), CLASS_INPUT_SELECT);
        },
        get selectFields() {
            return context.querySelectorAll(SELECTOR_SELECT_FIELDS);
        }
    };

    viabovag.toast = new Toast(refs.toast);

    let facetsRequestRetryCount = 0;
    let resultsRequestRetryCount = 0;
    let longLoadTimeout = null;

    refs.fieldPostalCodeCity.addEventListener('autocomplete-entry-valid', event => {
        if (event.detail) {
            enableDistanceSorting();
            enableDistanceField();
        } else {
            disableDistanceSorting();
            disableDistanceField();
        }

        updateFacets();
        updateResults();
    });

    refs.fieldPostalCodeCity.addEventListener('autocomplete-entry-invalid', () => {
        disableDistanceSorting();
        disableDistanceField();
    });

    function enableDistanceField() {
        const distanceField = closest(refs.fieldDistance, 'input-select');
        distanceField.jsApi.enable();
    }

    function disableDistanceField() {
        const distanceField = closest(refs.fieldDistance, 'input-select');
        distanceField.jsApi.disable();
    }

    function enableDistanceSorting() {
        const distanceSortingOption = refs.fieldSortOrderSelect.querySelector(
            `[value="${SORTING_DISTANCE_OPTION_ENABLEDTEXT}"]`
        );
        if (distanceSortingOption) {
            distanceSortingOption.disabled = false;
            distanceSortingOption.text = SORTING_DISTANCE_OPTION_ENABLEDTEXT;
        }
        const selectedSortingOption = refs.fieldSortOrderSelect.options[refs.fieldSortOrderSelect.selectedIndex].value;
        if (selectedSortingOption === SORTING_DISTANCE_OPTION_ENABLEDTEXT) {
            refs.fieldSortOrder.value = selectedSortingOption.value;
        }
    }

    function disableDistanceSorting() {
        const selectedSortingOption = refs.fieldSortOrderSelect.options[refs.fieldSortOrderSelect.selectedIndex].value;
        if (selectedSortingOption === SORTING_DISTANCE_OPTION_ENABLEDTEXT) {
            refs.fieldSortOrder.value = refs.fieldSortOrderSelect.options[0].selected.value;
        }
        const distanceSortingOption = refs.fieldSortOrderSelect.querySelector(
            `[value="${SORTING_DISTANCE_OPTION_ENABLEDTEXT}"]`
        );
        if (distanceSortingOption) {
            distanceSortingOption.disabled = true;
            distanceSortingOption.text = SORTING_DISTANCE_OPTION_DISABLEDTEXT;
        }
    }

    if (document.documentElement.classList.contains('ua-android')) {
        refs.fieldPostalCodeCity.addEventListener('focus', () => {
            refs.fieldPostalCodeCity.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    }

    function init() {
        initEventRegistration();
        initEcommerceEvents();
        initState();
        initSorting();
        initLastSearchRequest();
        setInputOrderDisplayMode();

        if (refs.keywordsField) {
            refs.keywordsField.jsApi.subscribeToEvent('submit', () => {
                handleSearchSubmit(refs.keywordsField, 'srp.facets.trefwoord');
            });
        }

        if (refs.modelKeywordsField) {
            refs.modelKeywordsField.jsApi.subscribeToEvent('submit', () => {
                handleSearchSubmit(refs.modelKeywordsField, 'srp.facets.modelTrefwoord');
            });
        }

        evaluateBtnSnap();

        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', onResize);
    }

    function onScroll() {
        requestAnimationFrame(evaluateBtnSnap);
    }

    function onResize() {
        requestAnimationFrame(evaluateBtnSnap);
    }

    function evaluateBtnSnap() {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const boundingClientRect = refs.filtersContainer.getBoundingClientRect();

        if (boundingClientRect.bottom < viewportHeight) {
            refs.fixedActions.classList.add(CLASS_BUTTON_SNAPPED);
        } else {
            refs.fixedActions.classList.remove(CLASS_BUTTON_SNAPPED);
        }
    }

    function handleSearchSubmit(searchField, eventCategory) {
        const searchFieldInput = closest(searchField.jsApi.refs.inputText, CLASS_INPUT_TEXT);

        if (validator.validateField(searchFieldInput).isValid) {
            Analytics.trackEvent(eventCategory, 'Custom Event', searchField.jsApi.refs.inputText.value);

            updateFacets();
            updateResults();
        }
    }

    refs.form.addEventListener('submit', e => e.preventDefault());

    const filterCloud = viabovag.getInstanceByNode(refs.filterCloudNode);

    filterCloud.jsApi.pubsub.subscribe('clearFilters', () => resetFilters());
    filterCloud.jsApi.pubsub.subscribe('removeFilter', ({ filterId }) => handleRemoveFilter(filterId));

    function handleRemoveFilter(filterId) {
        if (filterId === ID_POSTAL_CODE_DISTANCE_FILTER || filterId === ID_CITY_DISTANCE_FILTER) {
            resetPostalCodeCity();
        } else if (filterId === ID_CAR_COMPANY_FILTER) {
            refs.fieldCarCompanyId.value = '';
            refs.fieldCarCompanyName.value = '';
        } else if (filterId === ID_COMPANY_FRANCHISE_FILTER) {
            refs.fieldCompanyFranchise.value = '';
        } else {
            const filter = context.querySelector(`#${filterId}`);

            if (filter) {
                if (isCheckbox(filter)) {
                    if (filterId === ID_IN_STOCK) {
                        filter.checked = true;
                    } else {
                        filter.parentElement.jsApi.reset();
                    }
                } else if (filterId === ID_KEYWORDS || filterId === ID_MODEL_KEYWORDS) {
                    filter.parentElement.parentElement.jsApi.reset();
                } else {
                    if (filterId === ID_BRAND && refs.fieldModel) {
                        refs.fieldModel.parentElement.jsApi.reset();
                    }
                    filter.jsApi.reset();
                }
            }
        }
        updateFacets();
        updateResults();
    }

    function initState() {
        setState(refs.searchFilters, STATE_IDLE);
        setState(refs.searchResults, STATE_IDLE);
    }

    function initSorting() {
        postalCodeIsValid() ? enableDistanceSorting() : disableDistanceSorting();
    }

    function getState(node) {
        return node.getAttribute(ATTR_STATE);
    }

    function setState(node, state) {
        node.setAttribute(ATTR_STATE, state);
    }

    function resetPostalCodeCity() {
        resetSortingWhenSortingOnDistance();
        const wrapper = closest(refs.fieldPostalCodeCity, 'input-autocomplete');
        wrapper.jsApi.reset();
    }

    function resetSortingWhenSortingOnDistance() {
        const selectedSortingOption = refs.fieldSortOrderSelect.options[refs.fieldSortOrderSelect.selectedIndex].value;
        if (selectedSortingOption === SORTING_DISTANCE_OPTION_ENABLEDTEXT) {
            refs.fieldSortOrderSelect.options[0].selected = 'true';
            refs.fieldSortOrder.value = refs.fieldSortOrderSelect.value;
        }
        disableDistanceSorting();
    }

    function isCheckbox(node) {
        return node.tagName.toLowerCase() === 'input' && node.type === 'checkbox';
    }

    refs.filterToggler.addEventListener('click', e => {
        e.preventDefault();

        if (filtersAreShown()) {
            hideFilters();
        } else {
            showFilters();
        }
    });

    function resetCheckboxEvents() {
        getters.checkboxes.forEach(checkbox => checkbox.removeEventListener('change', onCheckboxChange));
    }

    function handleCheckboxEvents() {
        getters.checkboxes.forEach(checkbox => checkbox.addEventListener('change', onCheckboxChange));
    }

    function onCheckboxChange() {
        updateFacets();
        updateResults();
    }

    function resetFilters() {
        resetSortingWhenSortingOnDistance();
        updateFacets({ initial: true });
        updateResults({ initial: true });
    }

    if (refs.fieldModel) {
        refs.fieldBrand.addEventListener('change', e => {
            const fieldModel = closest(refs.fieldModel, CLASS_INPUT_SELECT);

            fieldModel.jsApi.clear();
            if (e.target.value.trim().length > 0) {
                fieldModel.jsApi.enable();
            } else {
                fieldModel.jsApi.disable();
            }
        });
    }

    refs.fieldPostalCodeCity.addEventListener('input', () => {
        const looksLikePostalCode = validationPatterns.partialPostalCode.test(refs.fieldPostalCodeCity.value);
        if (looksLikePostalCode) {
            applyAllCapsClassForPostalCodeCity();
        } else {
            unApplyAllCapsClassForPostalCodeCity();
        }
    });

    refs.fieldPostalCodeCity.addEventListener('input', () => {
        const fieldPostalCodeCityWrapper = closest(refs.fieldPostalCodeCity, CLASS_INPUT_TEXT);
        const value = fieldPostalCodeCityWrapper.jsApi.getValue();

        if (validationPatterns.partialPostalCode.test(value)) {
            fieldPostalCodeCityWrapper.jsApi.setValue(stripWhiteSpace(value));
        }
    });

    refs.fieldSortOrderSelect.addEventListener('change', () => {
        resetPageNumber();

        refs.fieldSortOrder.value = refs.fieldSortOrderSelect.value;
    });

    refs.fieldPageNumber.addEventListener('change', () => {
        scrollTo(refs.searchResults, -20, 0);

        updateResults();
    });

    getters.selectFields.forEach(selectField => {
        if (!selectField.isEqualNode(refs.fieldSortOrderSelect)) {
            selectField.addEventListener('change', updateFacets);
        }
        selectField.addEventListener('change', updateResults);
    });

    refs.fieldDistance.addEventListener('change', () => {
        const fieldPostalCodeCityWrapper = closest(refs.fieldPostalCodeCity, CLASS_INPUT_AUTOCOMPLETE);
        const fieldPostalCodeCityState = getState(fieldPostalCodeCityWrapper);

        if (
            fieldPostalCodeCityState === 'success' ||
            (fieldPostalCodeCityState === 'untouched' && refs.fieldPostalCodeCity.value)
        ) {
            updateFacets();
            updateResults();
        }
    });

    /**
     * Check if filters overlay is shown
     * @returns {boolean}
     */
    function filtersAreShown() {
        return context.classList.contains(CLASS_FILTERS_ARE_SHOWN);
    }

    function showFilters() {
        context.classList.add(CLASS_FILTERS_ARE_SHOWN);
        refs.filterToggler.classList.remove(CLASS_CTA_PRIMARY_WITH_ICON);
    }

    function hideFilters() {
        window.scrollTo(0, 0);
        context.classList.remove(CLASS_FILTERS_ARE_SHOWN);
        refs.filterToggler.classList.add(CLASS_CTA_PRIMARY_WITH_ICON);
        refs.absoluteWrapper.scrollTop = 0;
    }

    function updateFacets({ initial = false } = {}) {
        refs.filterToggler.classList.add(STATE_BUSY);
        setState(refs.searchFilters, STATE_BUSY);

        if (longLoadTimeout === null) {
            longLoadTimeout = setTimeout(() => {
                refs.filterToggler.classList.add('long-load');
            }, 2500);
        }

        resetPageNumber();

        const requestConfig = getFacetsRequestConfig();

        fireUpdateRequest({
            initial,
            requestConfig,
            apiConnectorFunction: apiConnector.getSearchFacets
        });
    }

    function getFacetsRequestConfig() {
        return {
            success: xhr => {
                const response = JSON.parse(xhr.responseText);

                processFacetsResults(response);
                resetCheckboxEvents();
                handleCheckboxEvents();

                setLastSearchRequest({
                    mobilityType: refs.fieldMobilityType.value,
                    searchResultsPageUrl: response.searchResultsPageUrl,
                    selectedFacets: response.selectedFacets
                });

                filterCloud.jsApi.processResponse(response.selectedFacets);

                clearLoadingState();
                setState(refs.searchFilters, STATE_IDLE);
                facetsRequestRetryCount = 0;
            },
            error: () => {
                facetsRequestRetryCount += 1;
                if (facetsRequestRetryCount < 3) {
                    updateFacets();
                } else {
                    facetsRequestRetryCount = 0;
                    clearLoadingState();
                }
            }
        };
    }

    function resetPageNumber() {
        refs.fieldPageNumber.value = '';
    }

    function getPageNumber() {
        return parseInt(refs.fieldPageNumber.value, 10) || 1;
    }

    function updateResults({ initial = false } = {}) {
        setState(refs.searchResults, STATE_BUSY);

        const requestConfig = getResultsRequestConfig();

        fireUpdateRequest({
            initial,
            requestConfig,
            apiConnectorFunction: apiConnector.getSearchResults
        });
    }

    function getResultsRequestConfig() {
        return {
            success: xhr => {
                const searchResultsPageUrl = xhr.getResponseHeader('Search-Results-Page-Url');
                const newSearchResultsPageUrl = window.location.origin + searchResultsPageUrl;

                window.history.pushState(newSearchResultsPageUrl, document.title, newSearchResultsPageUrl);
                processResults(xhr.responseText);
                clearLoadingState();
                setState(refs.searchResults, STATE_IDLE);
                resultsRequestRetryCount = 0;
            },
            error: () => {
                resultsRequestRetryCount += 1;
                if (resultsRequestRetryCount < 3) {
                    updateResults();
                } else {
                    resultsRequestRetryCount = 0;
                }
            }
        };
    }

    function postalCodeIsValid() {
        const fieldPostalCodeCityWrapper = closest(refs.fieldPostalCodeCity, CLASS_INPUT_TEXT);
        const fieldPostalCodeCityState = getState(fieldPostalCodeCityWrapper);
        return !(
            (fieldPostalCodeCityState && fieldPostalCodeCityState === 'error') ||
            refs.fieldPostalCodeCity.value.length === 0
        );
    }

    function fireUpdateRequest({ initial, requestConfig, apiConnectorFunction }) {
        if (initial) {
            requestConfig.serializedData = createInitialFormData();

            clearCarCompanyFilter();
            clearCompanyFranchiseFilter();
            apiConnectorFunction(requestConfig);
        } else {
            const isvalidPostalCode = postalCodeIsValid();

            if (!isvalidPostalCode) {
                refs.fieldPostalCodeCity.disabled = true;
                refs.fieldDistance.disabled = true;
            }

            if (refs.keywordsField) {
                if (!isValidSearch(refs.keywordsField)) {
                    refs.keywordsField.jsApi.refs.inputText.disabled = true;
                }
            }

            if (refs.modelKeywordsField) {
                if (!isValidSearch(refs.modelKeywordsField)) {
                    refs.modelKeywordsField.jsApi.refs.inputText.disabled = true;
                }
            }

            requestConfig.formReference = refs.form;
            apiConnectorFunction(requestConfig);

            if (!isvalidPostalCode) {
                refs.fieldPostalCodeCity.disabled = false;
                refs.fieldDistance.disabled = false;
            }

            if (refs.keywordsField) {
                refs.keywordsField.jsApi.refs.inputText.disabled = false;
            }

            if (refs.modelKeywordsField) {
                refs.modelKeywordsField.jsApi.refs.inputText.disabled = false;
            }
        }
    }

    function isValidSearch(searchField) {
        const searchFieldInput = closest(searchField.jsApi.refs.inputText, CLASS_INPUT_TEXT);

        return validator.validateField(searchFieldInput).isValid;
    }

    function createInitialFormData() {
        const mobilityTypeData = `${refs.fieldMobilityType.name}=${refs.fieldMobilityType.value}`;
        const inStockData = refs.fieldInStock ? `${refs.fieldInStock.name}=true` : null;

        return [mobilityTypeData, inStockData].filter(Boolean).join('&');
    }

    window.addEventListener('load', () => {
        setTimeout(() => {
            window.addEventListener('popstate', event => {
                if (event.state !== null && typeof event.state !== 'undefined') {
                    window.location.href = event.state;
                } else {
                    window.location.reload();
                }
            });
        }, 0);
    });

    /**
     * Populate search results box
     * Add exit animation for current items
     * Add entry animation for new items
     * Reload the tooltips as search results may have tooltips
     * @param results
     */
    function processResults(results) {
        refs.dynamicWrapper.innerHTML = results;

        triggerJs('cta-call', ctaCall, refs.searchResults);

        initEventRegistration();

        mediaLoader.prepareLazyLoadElements();

        window.viabovag.tooltips = new ToolTips();
    }

    function findFieldDataInFacets(facets, fieldName) {
        return facets.find(facet => facet.name === fieldName);
    }

    function updateCountNodes(value) {
        refs.countNodes.forEach(countNode => {
            countNode.innerHTML = value;
        });
    }

    /**
     * Process facets configuration for each facet
     * Adjust button state
     * @param results
     */
    function processFacetsResults(results) {
        context.classList.remove(CLASS_SINGLE_RESULT);
        context.classList.remove(CLASS_NO_RESULTS);

        if (results.count === 1) {
            context.classList.add(CLASS_SINGLE_RESULT);
        }

        if (results.count === 0) {
            context.classList.add(CLASS_NO_RESULTS);

            updateCountNodes('0');

            if (filtersAreShown()) {
                refs.submitButton.disabled = true;
            }
        } else {
            refs.submitButton.disabled = false;

            updateCountNodes(results.count.toLocaleString('nl-NL'));
        }

        manageAccordionState(results.facets);

        results.facets = adjustPostalCodeCityFacets(results.facets);

        for (let i = 0; i < results.facets.length; i++) {
            const facet = results.facets[i];
            const componentInfo = getUpdatableComponentAndType(facet.name);

            if (typeof componentInfo !== 'undefined') {
                processFacet({ facet, componentInfo, results });
            }
        }

        const updatedComponents = context.querySelectorAll('[data-component-updated]');

        updatedComponents.forEach(component => component.removeAttribute('data-component-updated'));
    }

    function processFacet({ facet, componentInfo, results }) {
        switch (componentInfo.type) {
            case 'input-select':
                updateInputSelectFacet({ facet, componentInfo });
                break;

            case 'checkbox-group': {
                if (facet.name === 'Accessory') {
                    updateAccessoryFacet({ facet });

                    break;
                }

                const multiSelectNode = closest(componentInfo.component, 'multi-select');

                if (multiSelectNode) {
                    updateMultiSelect(multiSelectNode, facet.options);

                    break;
                }

                updateCheckboxGroupFacet({ facet, componentInfo });
                break;
            }

            case 'input-range': {
                const needsUpdate = componentInfo.component.getAttribute('data-component-updated') === null;

                if (!needsUpdate) {
                    break;
                }

                updateInputRangeFacet({ facets: results.facets, componentInfo });
                break;
            }

            case 'input-checkbox':
                updateInputCheckboxFacet({ facet, componentInfo });
                break;

            case 'input-text':
                updateInputTextFacet({ facet, componentInfo });
                break;

            case 'input-autocomplete':
                updateInputAutocompleteFacet({ facet, componentInfo });
                break;

            // no default
        }

        handleFacetHiddenState({ facet, componentInfo });
    }

    function handleFacetHiddenState({ facet, componentInfo }) {
        if (facet.name === 'Accessory') {
            return;
        }

        const fieldsetItemNode = componentInfo.component.closest(SELECTOR_FIELDSET_ITEM);
        const filterItemNode = fieldsetItemNode.closest(SELECTOR_FILTER_ITEM);

        fieldsetItemNode.hidden = facet.hidden;

        if (filterItemNode && fieldsetItemNode.parentNode.children.length === 1) {
            filterItemNode.hidden = facet.hidden;
            filterItemNode.closest('.active').hidden = [...filterItemNode.parentNode.children].every(
                filterItem => filterItem.hidden
            );
        }
    }

    function adjustPostalCodeCityFacets(facets) {
        // the postal code and city facets both map to the single 'PostalCodeCity' field.
        // remove those two facets, and add a new one with the right name and value
        const postalCodeFacet = facets.find(f => f.name === 'PostalCode') || {};
        const cityFacet = facets.find(f => f.name === 'City') || {};
        const adjustedFacets = facets.filter(f => f.name !== 'City' && f.name !== 'PostalCode');
        adjustedFacets.push({
            name: 'PostalCodeCity',
            disabled: false,
            value: postalCodeFacet.value || cityFacet.value,
            selected: postalCodeFacet.selected || cityFacet.selected
        });
        return adjustedFacets;
    }

    function applyAllCapsClassForPostalCodeCity() {
        const fieldPostalCodeCityWrapper = closest(refs.fieldPostalCodeCity, CLASS_INPUT_TEXT);
        fieldPostalCodeCityWrapper.classList.add(CLASS_INPUT_POSTAL_CODE);
    }

    function unApplyAllCapsClassForPostalCodeCity() {
        const fieldPostalCodeCityWrapper = closest(refs.fieldPostalCodeCity, CLASS_INPUT_TEXT);
        fieldPostalCodeCityWrapper.classList.remove(CLASS_INPUT_POSTAL_CODE);
    }

    function updateInputSelectFacet({ facet, componentInfo }) {
        if (typeof facet.options !== 'undefined' || typeof facet.optionCategories !== 'undefined') {
            const options = facet.options || [];
            const optionCategories = facet.optionCategories || [];

            componentInfo.component.jsApi.populate(options, optionCategories);
        }

        if (facet.disabled) {
            componentInfo.component.jsApi.disable();
        }
    }

    function updateCheckboxGroupFacet({ facet, componentInfo }) {
        const filterItemNode = closest(componentInfo.component, 'filter__item');

        toggle(filterItemNode, facet.options.length > 0);

        const data = [];

        facet.options.forEach(option => {
            const optionSettings = {
                id: `${facet.name}-${option.name}`,
                label: `${option.label}`,
                value: `${option.name}`,
                checked: option.selected || false,
                tooltip: option.tooltip
            };

            if ('count' in option) {
                optionSettings.count = option.count;
            }

            if (typeof facet.hasIcons !== 'undefined' && facet.hasIcons === true) {
                optionSettings.icon = camelToKebab(`${facet.name}-${option.name}`);
            }

            data.push(optionSettings);
        });

        componentInfo.component.jsApi.updateState(data);
    }

    function updateInputRangeFacet({ facets, componentInfo }) {
        const selectNodeFrom = componentInfo.component.querySelectorAll('select')[0];
        const selectNodeTo = componentInfo.component.querySelectorAll('select')[1];

        const fromData = findFieldDataInFacets(facets, selectNodeFrom.name);
        const toData = findFieldDataInFacets(facets, selectNodeTo.name);

        if (fromData && toData) {
            componentInfo.component.jsApi.updateStateByData({
                from: getAdaptedRangeInputData(fromData.options),
                to: getAdaptedRangeInputData(toData.options)
            });

            componentInfo.component.setAttribute('data-component-updated', true);
        }
    }

    function updateInputCheckboxFacet({ facet, componentInfo }) {
        if (typeof facet.selected === 'undefined' || facet.selected === false) {
            componentInfo.component.jsApi.reset();
        } else {
            componentInfo.component.jsApi.check();
        }
    }

    function updateInputTextFacet({ facet, componentInfo }) {
        if (typeof facet.selected === 'undefined' || facet.selected === false) {
            componentInfo.component.jsApi.reset();
        }
    }

    function updateInputAutocompleteFacet({ facet, componentInfo }) {
        if (typeof facet.selected === 'undefined' || facet.selected === false) {
            if (!componentInfo.component.jsApi.hasSuggestions()) {
                componentInfo.component.jsApi.reset();
            }
        }
    }

    function updateAccessoryFacet({ facet }) {
        refs.accessoryGroups.forEach(groupNode => updateAccessoryGroup(groupNode, facet.options));
    }

    function updateAccessoryGroup(groupNode, accessories) {
        const groupAccessories = getGroupAccessoiries(groupNode);
        const activeAccessories = accessories.filter(accessory => groupAccessories.includes(accessory.name));

        const checkboxGroupNode = groupNode.querySelector('[data-group-name]');
        const checkboxGroupAPI = checkboxGroup(checkboxGroupNode);

        toggle(groupNode, activeAccessories.length > 0);

        const checkboxGroupData = activeAccessories.map(({ label, name, selected }) => ({
            label,
            value: name,
            checked: selected || false
        }));

        checkboxGroupAPI.updateState(checkboxGroupData);
    }

    function getGroupAccessoiries(groupNode) {
        return groupNode.getAttribute('data-accessory-items').split(',');
    }

    function getAdaptedRangeInputData(options) {
        const adaptedData = {
            options: []
        };

        options.forEach(({ label, name, selected }) => {
            adaptedData.options.push({ label, name, selected });

            if (selected) {
                adaptedData.value = name;
            }
        });

        return adaptedData;
    }

    function updateMultiSelect(multiSelectNode, options) {
        multiSelectNode.jsApi.updateByState(options);
    }

    function manageAccordionState(facets) {
        const accordionItems = [
            {
                name: 'eigenschappen',
                facetNames: ['FuelType', 'Transmission', 'BodyType', 'DoorCount', 'SeatCount', 'GearCount', 'Condition']
            },
            {
                name: 'algemeen-caramper',
                facetNames: ['Condition', 'Import']
            },
            {
                name: 'garantie',
                facetNames: ['Warranty']
            },
            {
                name: 'kleur',
                facetNames: ['Color']
            },
            {
                name: 'type',
                facetNames: ['VehicleType']
            },
            {
                name: 'opties',
                facetNames: ['Accessory']
            }
        ];

        accordionItems.forEach(accordionItem => {
            const accordionItemNode = getAccordionItemNodeByName(accordionItem.name);

            if (!accordionItemNode) {
                return;
            }

            const hasOptions = accordionItem.facetNames.some(facetName => {
                const facetNode = accordionItemNode.querySelector(`[data-group-name=${facetName}]`);

                if (!facetNode) {
                    return false;
                }

                const facet = getFacetDataByName(facetName, facets);

                if (facetName === 'Accessory') {
                    return [...refs.accessoryGroups].some(groupNode => {
                        const groupAccessories = getGroupAccessoiries(groupNode);

                        return facet.options.some(facetOption => groupAccessories.includes(facetOption.name));
                    });
                }

                return facet.options.length > 0;
            });

            accordionItemNode.hidden = !hasOptions;
        });
    }

    function getFacetDataByName(name, facets) {
        return facets.find(facet => facet.name === name);
    }

    function getAccordionItemNodeByName(name) {
        return document.querySelector(`[data-ref="${name}"]`)?.parentNode;
    }

    function getUpdatableComponentAndType(fieldName) {
        const componentsToUpdate = [
            'input-autocomplete',
            'input-range',
            'input-select',
            'checkbox-group',
            'input-checkbox',
            'input-text'
        ];

        const field =
            context.querySelector(`[data-group-name="${fieldName}"]`) || context.querySelector(`[name="${fieldName}"]`);

        let obj;

        if (field !== null) {
            const componentName = componentsToUpdate.find(clsName => closest(field, clsName));
            const component = closest(field, componentName);

            if (component) {
                obj = {
                    type: componentName,
                    component
                };
            }
        }

        return obj;
    }

    handleCheckboxEvents();

    function clearLoadingState() {
        clearInterval(longLoadTimeout);
        longLoadTimeout = null;
        refs.filterToggler.classList.remove(STATE_BUSY);
        refs.filterToggler.classList.remove('long-load');
    }

    function clearCarCompanyFilter() {
        if (refs.fieldCarCompanyId) {
            refs.fieldCarCompanyId.value = '';
        }
        if (refs.fieldCarCompanyName) {
            refs.fieldCarCompanyName.value = '';
        }
    }

    function clearCompanyFranchiseFilter() {
        if (refs.fieldCompanyFranchise) {
            refs.fieldCompanyFranchise.value = '';
        }
    }

    function setInputOrderDisplayMode() {
        const displayMode = breakpoints.onBreakpointOrGreater('tablet') ? 'inline' : 'floating';

        getters.inputSelectOrderNode.jsApi.setDisplayMode(displayMode);
    }

    function addSearchCookieEvents() {
        const searchResults = document.querySelectorAll(SELECTOR_SEARCH_RESULT);
        searchResults.forEach((searchResultItem, index) => {
            const links = searchResultItem.querySelectorAll(SELECTOR_DATA_SEARCH_COOKIE);
            const currentPage = getPageNumber();
            const selectedIndex = index + (currentPage - 1) * RESULTS_SHOWN_AMOUNT + 1;
            links.forEach(linkNode => {
                linkNode.addEventListener('click', event =>
                    handleSearchResultLinkClick(linkNode, selectedIndex, event)
                );
                linkNode.addEventListener('contextmenu', () => generateSearchCookie(selectedIndex));
                linkNode.addEventListener('auxclick', event => {
                    if (event.button === 1) {
                        handleSearchResultLinkClick(linkNode, selectedIndex, event, true);
                    }
                });
            });
        });
    }

    /**
     * Gets triggered when clicked on a search result
     * @param {Node} searchItem
     * @param {number} selectedIndex
     * @param {Event} event
     * @param {boolean} newTab
     */
    function handleSearchResultLinkClick(searchItem, selectedIndex, event, newTab = false) {
        event.preventDefault();
        const tooltipClasses = ['more-info', 'icon-info', 'tippy-box'];
        const ignoreClasses = ['favorite', 'icon-heart', ...tooltipClasses];

        let ignoreClick = false;
        let linkInTooltipClick = false;
        if (elementOrParentsHasOneOfClassNames(event.target, ignoreClasses)) {
            ignoreClick = true;
        }

        // Check if event is a hyperlink in a tooltip
        if (event.target.tagName === 'A') {
            const eventTarget = event.target;
            if (elementOrParentsHasOneOfClassNames(eventTarget, tooltipClasses)) {
                linkInTooltipClick = true;
                if (window.event.ctrlKey || eventTarget.target === '_blank') {
                    window.open(eventTarget.href);
                } else {
                    window.location = eventTarget.href;
                }
            }
        }

        if (ignoreClick || linkInTooltipClick) {
            return;
        }

        generateSearchCookie(selectedIndex);
        if (window.event.ctrlKey || searchItem.target === '_blank') {
            newTab = true;
        }
        if (newTab) {
            window.open(searchItem.href);
        } else {
            window.location = searchItem.href;
        }
    }

    /**
     * @param {string} name
     * @returns {string}
     */
    function getCookie(name) {
        function escape(s) {
            return s.replace(/([.*+?^$(){}|[\]/\\])/g, '\\$1');
        }
        const match = document.cookie.match(RegExp(`(?:^|;\\s*)${escape(name)}=([^;]*)`));
        return match ? match[1] : null;
    }

    /**
     * Transform object to an array to sort on timestamp, add a max length
     * @param {Object} data
     * @returns {Object} sortedDictionary
     */
    function cleanupCookie(data) {
        const sortedDictionary = {};
        const dictionaryList = [];
        if (data) {
            const dictionaryKeys = Object.keys(data);
            dictionaryKeys.forEach(dictionaryKey => {
                dictionaryList.push({ key: dictionaryKey, timestamp: data[dictionaryKey].timestamp });
            });
            dictionaryList.sort((a, b) => {
                return b.timestamp > a.timestamp ? 1 : -1;
            });
            dictionaryList.length = COOKIE_SRP_MAX;
            dictionaryList.forEach(item => {
                sortedDictionary[item.key] = data[item.key];
            });
            return sortedDictionary;
        }
        return data;
    }

    function getSearchCookie() {
        const searchCookie = getCookie(COOKIE_SRP_NAME);
        if (!searchCookie) {
            return {};
        }

        const searchResultsInteractionDictionary = JSON.parse(atob(searchCookie));

        return cleanupCookie(searchResultsInteractionDictionary);
    }

    function generateSearchCookie(selectedIndex) {
        const totalCountEl = document.querySelector(SELECTOR_COUNT_NODE);
        const totalNumberOfResults = totalCountEl.innerText.replace(/\D/, '');
        const cookie = getSearchCookie();
        const timestamp = Date.now();

        const interaction = {
            totalNumberOfResults,
            selectedIndex,
            timestamp
        };

        cookie[window.location.pathname] = interaction;
        const newCookie = JSON.stringify(cookie);
        const encodedCookieValue = btoa(newCookie);
        document.cookie = `${COOKIE_SRP_NAME}=${encodedCookieValue};path=/`;
    }

    function initEventRegistration() {
        const eventDefinitions = [
            {
                eventName: 'search-result-company-deeplink-clicked',
                cssSelector: '[data-track="srp.website"]'
            }
        ];

        eventDefinitions.forEach(({ eventName, cssSelector }) => {
            const nodes = document.querySelectorAll(cssSelector);

            nodes.forEach(node => {
                const vehicleId = node.getAttribute('data-track-label');

                node.addEventListener('click', () => {
                    registerEvent({
                        eventName,
                        payload: {
                            vehicleId
                        }
                    });
                });
            });
        });

        addSearchCookieEvents();
    }

    function initEcommerceEvents() {
        delegateEvent(SELECTOR_SEARCH_RESULT, 'click', node => {
            registerEcommerceEvent('productClick', {
                click: {
                    actionField: {
                        list: getMobilityTypeFromVehicleNode(node)
                    },
                    products: [getProductDataFromVehicleNode(node)]
                }
            });
        });

        window.addEventListener('scroll', registerProductImpressions);
    }

    function registerProductImpressions() {
        const searchResultItems = refs.searchResults.querySelectorAll(SELECTOR_SEARCH_RESULT);

        searchResultItems.forEach((searchResultItem, index) => {
            if (touchesViewport(searchResultItem) && !searchResultItem.hasAttribute(ATTR_VIEWED)) {
                searchResultItem.setAttribute(ATTR_VIEWED, '');

                registerEcommerceEvent('productImpression', {
                    currencyCode: 'EUR',
                    impressions: [
                        {
                            ...getProductDataFromVehicleNode(searchResultItem),
                            position: (getPageNumber() - 1) * RESULTS_SHOWN_AMOUNT + index + 1,
                            list: getMobilityTypeFromVehicleNode(searchResultItem)
                        }
                    ]
                });
            }
        });
    }

    function initLastSearchRequest() {
        const mobilityTypeNode = document.querySelector('[name="MobilityType"]');

        if (!mobilityTypeNode) {
            return;
        }

        const mobilityType = mobilityTypeNode.value;

        renderLastSearchRequest(mobilityType);
    }

    window.addEventListener('resize', () => {
        filterCloud.jsApi.determineFilterContainerWidth();

        setInputOrderDisplayMode();
    });

    init();

    return {
        resetFilters
    };
};
